// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_d8-0";
export var fileCarousel = "_d8-2";
export var removeFileButton = "_d8-1";